// extracted by mini-css-extract-plugin
export default {"container":"AddCommandBar_container__tWeik","title":"AddCommandBar_title__wKczX"};